import React from "react";
import HeroInternship from "../../components/page-components/internship/HeroInternship";
import AllBranches from "../../components/page-components/internship/AllBranch";
import WhyUs from "../../components/page-components/internship/Whyus";
import HowWorks from "../../components/page-components/internship/HowWorks";
import Testimonials from "../../components/page-components/internship/Testimonial";
import AboutInternship from "../../components/page-components/internship/AboutInternship";
import InternshipCTA from "../../components/page-components/internship/Interncta";

function Internship() {
  return (
    <div>
      <HeroInternship />
      <AboutInternship />
      <AllBranches />
      <WhyUs />
      <HowWorks />
      <Testimonials />
      <InternshipCTA />
    </div>
  );
}

export default Internship;
